export default __webpack_public_path__ + "static/media/Logo.9da42620.png";